import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_asset_category = _resolveComponent("select-asset-category")!
  const _component_q_step = _resolveComponent("q-step")!
  const _component_select_brief = _resolveComponent("select-brief")!
  const _component_select_company = _resolveComponent("select-company")!
  const _component_select_asset = _resolveComponent("select-asset")!
  const _component_select_deal_type = _resolveComponent("select-deal-type")!
  const _component_select_mandatory_fields = _resolveComponent("select-mandatory-fields")!
  const _component_lead_confirmation = _resolveComponent("lead-confirmation")!
  const _component_q_stepper = _resolveComponent("q-stepper")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_dialog_skeleton = _resolveComponent("dialog-skeleton")!

  return (_openBlock(), _createBlock(_component_dialog_skeleton, {
    "cancel-label": _ctx.cancelBtnLabel,
    "confirm-tooltip": _ctx.confirmBtnTooltip,
    "secondary-label": _ctx.secondaryBtnLabel,
    "confirm-label": _ctx.confirmBtnLabel,
    "disable-confirm": _ctx.disableConfirm,
    loading: _ctx.loading,
    title: _ctx.t('TITLE.CREATE', { object: _ctx.t('LEAD.LOW.SING') }),
    ref: "dialog",
    onSecondary: _ctx.secondaryAction,
    onCancel: _ctx.revertStep,
    onConfirm: _ctx.nextStep
  }, {
    content: _withCtx(() => [
      _createVNode(_component_q_card, {
        class: "bg-white",
        flat: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "q-pa-none" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_stepper, {
                animated: "",
                "keep-alive": "",
                color: "primary",
                contracted: "",
                flat: "",
                "header-class": "hidden",
                ref: "stepper",
                modelValue: _ctx.step,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_step, {
                    done: _ctx.step > _ctx.LeadFormSteps.SELECT_CATEGORY,
                    name: _ctx.LeadFormSteps.SELECT_CATEGORY,
                    class: "q-pb-lg",
                    title: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_select_asset_category, {
                        "selected-category": _ctx.selectedCategory,
                        step: _ctx.LeadFormSteps.SELECT_CATEGORY,
                        onSelectedCategory: _ctx.selectCategory,
                        "on@nextStep": _ctx.nextStep
                      }, null, 8, ["selected-category", "step", "onSelectedCategory", "on@nextStep"])
                    ]),
                    _: 1
                  }, 8, ["done", "name"]),
                  _createVNode(_component_q_step, {
                    done: _ctx.step > _ctx.LeadFormSteps.SELECT_BRIEF,
                    name: _ctx.LeadFormSteps.SELECT_BRIEF,
                    class: "q-pb-lg",
                    title: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_select_brief, {
                        "default-brief-id": _ctx.defaultBrief?.dobjId,
                        "preselected-brief-id": _ctx.preselectedBriefId,
                        "selected-brief": _ctx.selectedBrief,
                        step: _ctx.LeadFormSteps.SELECT_BRIEF,
                        onSelectedBrief: _ctx.selectBrief,
                        "on@nextStep": _ctx.nextStep
                      }, null, 8, ["default-brief-id", "preselected-brief-id", "selected-brief", "step", "onSelectedBrief", "on@nextStep"])
                    ]),
                    _: 1
                  }, 8, ["done", "name"]),
                  (_openBlock(), _createBlock(_component_q_step, {
                    done: _ctx.step > _ctx.LeadFormSteps.SELECT_COMPANY,
                    name: _ctx.LeadFormSteps.SELECT_COMPANY,
                    key: _ctx.selectedCategory,
                    class: "q-pb-lg",
                    title: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_select_company, {
                        "previous-search": _ctx.revertStepCompanyText,
                        "selected-category": _ctx.selectedCategory,
                        "selected-brief": _ctx.selectedBrief,
                        "selected-company": _ctx.selectedCompany,
                        "preselected-company-id": _ctx.preselectedCompanyId,
                        step: _ctx.LeadFormSteps.SELECT_COMPANY,
                        onSelectedCompany: _ctx.selectCompany,
                        "on@nextStep": _ctx.nextStep
                      }, null, 8, ["previous-search", "selected-category", "selected-brief", "selected-company", "preselected-company-id", "step", "onSelectedCompany", "on@nextStep"])
                    ]),
                    _: 1
                  }, 8, ["done", "name"])),
                  (_openBlock(), _createBlock(_component_q_step, {
                    done: _ctx.step > _ctx.LeadFormSteps.SELECT_ASSET,
                    name: _ctx.LeadFormSteps.SELECT_ASSET,
                    key: _ctx.selectedCategory,
                    class: "q-pb-lg",
                    title: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_component_select_asset, {
                        key: _ctx.assetKey,
                        "previous-search": _ctx.revertStepAssetText,
                        "selected-asset": _ctx.selectedAsset,
                        "selected-category": _ctx.selectedCategory,
                        "selected-brief": _ctx.selectedBrief,
                        "selected-company": _ctx.selectedCompany,
                        step: _ctx.LeadFormSteps.SELECT_ASSET,
                        onSelectedAsset: _ctx.selectAsset,
                        "on@nextStep": _ctx.nextStep
                      }, null, 8, ["previous-search", "selected-asset", "selected-category", "selected-brief", "selected-company", "step", "onSelectedAsset", "on@nextStep"]))
                    ]),
                    _: 1
                  }, 8, ["done", "name"])),
                  (_ctx.canChooseDealType && !_ctx.skipDealTypeSelection)
                    ? (_openBlock(), _createBlock(_component_q_step, {
                        key: 0,
                        done: _ctx.step > _ctx.LeadFormSteps.SELECT_DEAL_TYPE,
                        name: _ctx.LeadFormSteps.SELECT_DEAL_TYPE,
                        class: "q-pb-lg",
                        title: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_select_deal_type, {
                            step: 4,
                            "selected-category": _ctx.selectedCategory,
                            "pre-selected-deal-type": _ctx.selectedDealType?.dobjId,
                            onSelectedDealType: _ctx.selectDealTypeOrSkip,
                            "on@nextStep": _ctx.nextStep
                          }, null, 8, ["selected-category", "pre-selected-deal-type", "onSelectedDealType", "on@nextStep"])
                        ]),
                        _: 1
                      }, 8, ["done", "name"]))
                    : _createCommentVNode("", true),
                  (_ctx.mandatoryFieldsApply)
                    ? (_openBlock(), _createBlock(_component_q_step, {
                        key: 1,
                        name: _ctx.LeadFormSteps.MANDATORY,
                        done: _ctx.step > _ctx.LeadFormSteps.MANDATORY,
                        title: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_select_mandatory_fields, {
                            step: 5,
                            "mandatory-config-id-list": _ctx.mandatoryConfigIdList,
                            "layout-ids": _ctx.layoutIdList,
                            onCompleteUpdate: _ctx.completeUpdate,
                            onInfogroupDataUpdate: _ctx.infoGroupDataUpdate
                          }, null, 8, ["mandatory-config-id-list", "layout-ids", "onCompleteUpdate", "onInfogroupDataUpdate"])
                        ]),
                        _: 1
                      }, 8, ["name", "done"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_q_step, {
                    name: _ctx.LeadFormSteps.CONFIRM,
                    title: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lead_confirmation, {
                        "contact-id": _ctx.fromContactId,
                        "internal-contact-id": _ctx.fromInternalContactId,
                        loading: _ctx.loading,
                        "meeting-id": _ctx.fromMeetingId,
                        "origin-id": _ctx.originConferenceId || _ctx.originCampaignId,
                        "origin-entity": _ctx.originFromConference || _ctx.originFromCampaign,
                        "selected-category": _ctx.selectedCategory,
                        "selected-asset": _ctx.selectedAsset,
                        "selected-brief": _ctx.selectedBrief,
                        "selected-company": _ctx.selectedCompany,
                        "selected-deal-type": _ctx.selectedDealType,
                        "show-deal-type": _ctx.useDealWorkflow,
                        step: _ctx.LeadFormSteps.CONFIRM
                      }, null, 8, ["contact-id", "internal-contact-id", "loading", "meeting-id", "origin-id", "origin-entity", "selected-category", "selected-asset", "selected-brief", "selected-company", "selected-deal-type", "show-deal-type", "step"])
                    ]),
                    _: 1
                  }, 8, ["name"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["cancel-label", "confirm-tooltip", "secondary-label", "confirm-label", "disable-confirm", "loading", "title", "onSecondary", "onCancel", "onConfirm"]))
}